'use client';

import dynamic from 'next/dynamic';
import { JourneyLoadingMark } from './JourneyLoadingMark';

const Journey = dynamic(() => import('./Journey').then((m) => ({ default: m.Journey })), {
  ssr: false,
  loading: () => <JourneyLoadingMark />,
});

export function JourneyLoader({ initialSlug }: { initialSlug?: string }) {
  // tierOverride was removed — the layout-level QualityProvider now reads
  // `?tier=` directly via useSearchParams, so passing it through this chain
  // is redundant (and was the source of the dual-provider bug).
  return <Journey initialSlug={initialSlug} />;
}
